// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixWindow from 'wix-window';


$w.onReady(function () {
	//TODO: write your page related code here...

if(wixWindow.formFactor === "Mobile"){
	$w("#mobileMenu1").show();
}

});